import { Box, FormHelperText } from '@mui/material';
import CustomFormLabel from 'src/components/forms/theme-elements/CustomFormLabel';
import CustomTextField from 'src/components/forms/theme-elements/CustomTextField';

const FormInput = ({
  name,
  label,
  required = false,
  type = 'text',
  value,
  onChange,
  onBlur,
  error,
  helperText,
  InputProps,
  ...props
}) => {
  return (
    <>
     {label && <CustomFormLabel margin="0" required={required}>{label}</CustomFormLabel>} 
      <CustomTextField
        fullWidth
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        helperText={helperText}
        InputProps={InputProps}
        {...props}
      />
    </>
  );
};

export default FormInput;